/*
 *  Class Google Tracking
 */
export
default class GoogleTracking {
    constructor() {
        window.dataLayer = window.dataLayer || [];
    }

    pushToDataLayer(config) {
        window.dataLayer.push(config);
    }

    getCategoryItems() {
        const category = document.querySelector('a.is-current span, a.is-active span');
        const subCategory = document.querySelector('.sub-menu a.is-current span, .sub-menu a.is-active span');
        return {
            main: category ? category.innerHTML : null,
            sub: subCategory ? subCategory.innerHTML : null
        };
    }

    generalPageTracking() {
        const categoryItems = this.getCategoryItems();
        const hashId = '';

        this.pushToDataLayer({
            page: {
                category: categoryItems.main,
                subCategory: categoryItems.sub,
                campaignLanding: false
            },
            user: {
                loggedin: false,
                hashId: hashId
            }
        });
    }

    cleanTrackingCategory(category) {
        // category = 'subscription#pricevariant_new'
        // Remove #-ancors and ?-get params of given string
        if (!category) { return null; }
        category = category.split('#')[0];
        category = category.split('?')[0];
        return category;
    }

    cmsContentTracking() {
        const categoryItems = this.getCategoryItems();
        const elements = document.querySelectorAll('[ui-name]');
        if (!elements || !elements.length) return;

        let localCurrencyCode = null;
        let localImpressions = {};

        let ii = 1;
        for (let i = 0; i < elements.length; i++) {
            const name = elements[i].getAttribute('ui-name');
            const id = elements[i].getAttribute('ui-id');
            const price = elements[i].getAttribute('ui-price');
            const brand = elements[i].getAttribute('ui-brand');
            const category = elements[i].getAttribute('ui-category');
            const currencyCode = elements[i].getAttribute('ui-currencyCode');
            const offerType = elements[i].getAttribute('ui-offerType');

            if (!name || !id || !price || !brand) {
                console.warn('Required parameters missing for:', elements[i]);
                continue;
            }

            if (localImpressions[id]) continue;

            if (currencyCode && currencyCode.length) localCurrencyCode = currencyCode;

            localImpressions[id] = {
                name: `${name}`,
                id: `${id}`,
                price: `${price}`,
                brand: brand,
                category: category ? `${category}` : categoryItems.main,
                list: 'LIST',
                position: `${ii}`,

            };

            if (offerType) {
            	  localImpressions[id]['offer-type'] = offerType;
						}

            ii++;

        }

        const data = {
            event: 'eecImpressions',
            ecommerce: {
                currencyCode: localCurrencyCode ? localCurrencyCode : 'CHF',
                impressions: Object.values(localImpressions)
            }
        };

        if (data.ecommerce.impressions.length) this.pushToDataLayer(data);
    }

    cmsCheckoutSuccessTracking() {
        const element = document.querySelector('[ui-success-order]');
        if (!element) return;

        const order = element.getAttribute('ui-success-order');
        const value = element.getAttribute('ui-success-value');
        const name = element.getAttribute('ui-success-name');

        if (!order || !value || !name) {
            console.warn('Required parameters missing');
            return;
        }

        const data = {
            event: 'eecPurchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: order, // Transaction ID. Required! 'affiliation': 'Online Store',
                        revenue: value, // Total transaction value (incl. tax and shipping)
                        tax: 0.00,
                        shipping: 0.00,
                        coupon: ''
                    },
                    products: []
                }
            }
        };

        const payload = JSON.parse(window.sessionStorage.getItem('tata-checkout-payload'));
        window.sessionStorage.removeItem('tata-checkout-payload');

        if (!payload || !payload.cart) {
            console.warn('Required cart is missing for:', order);
            return;
        }

        if (!payload.cart.items || !payload.cart.items.length) {
            console.warn('No items in cart for:', order);
            return;
        }

        for (let i = 0; i < payload.cart.items.length; i++) {
            const product = payload.cart.items[i];

            if ('abo' === product.type) {
                data.ecommerce.purchase.products.push({
                    name: `${product.abo.name}`,
                    id: `${product.abo.aboId}`,
                    price: `${product.abo.monthlyFeeDiscounted ? product.abo.monthlyFeeDiscounted : product.abo.monthlyFee}`,
                    brand: `${product.abo.providerName ? product.abo.providerName : 'TalkTalk'}`,
                    category: `${this.cleanTrackingCategory(product.type)}`,
                    // 'category': 'Mobile Abos',
                    // 'variant': '',
                    // 'memory': '',
                    // 'dataVolume': '',
                    // 'networkSpeed': '',
                    // 'color': '',
                    // 'size': '',
                    // 'label': '', // Top Deal, Offer,
                    // 'type': '', //Bundle, Hardware, SIM, Internet 'provider': '',
                    // 'entryDate': '',
                    coupon: '',
                    quantity: product.abo.quantity ? product.abo.quantity : 1
                });
            }

            if ('sim' === product.type) {
                data.ecommerce.purchase.products.push({
                    name: `${product.abo.name}`,
                    id: `${product.abo.aboId}`,
                    price: `${product.abo.activationFeeDiscounted ? product.abo.activationFeeDiscounted : product.abo.activationFee}`,
                    brand: `${product.abo.providerName ? product.abo.providerName : 'TalkTalk'}`,
                    category: `${this.cleanTrackingCategory(product.type)}`,
                    // 'category': 'Mobile Abos',
                    // 'variant': '',
                    // 'memory': '',
                    // 'dataVolume': '',
                    // 'networkSpeed': '',
                    // 'color': '',
                    // 'size': '',
                    // 'label': '', // Top Deal, Offer,
                    // 'type': '', //Bundle, Hardware, SIM, Internet 'provider': '',
                    // 'entryDate': '',
                    coupon: '',
                    quantity: product.abo.quantity ? product.abo.quantity : 1
                });
            }
        }

        if (data.ecommerce.purchase.products.length) this.pushToDataLayer(data);
    }

    cmsCheckoutSuccessTrackingAfterPaymentOnSuccessPage() {
        const element = document.querySelector('.checkout.success.tata-company-organism-checkout-success');
        if (!element) return;

        const keysToFetchBy = ['order', 'grandTotal', 'simCard', 'email'];
        const productsKeysToFetchBy = [ 'productName', 'productId', 'productCosts', 'monthlyPrice' ];

        const parsedUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(parsedUrl.search);

        let eventObj = {
            event: 'purchase',
            ecommerce: {
                transaction_id: searchParams.get('order'),
                value: searchParams.get('grandTotal'),
                currency: 'CHF',
                // mz_custom_fields: {
                //     sim_type: searchParams.get('simCard'),
                // },
							  tax: 0.0,
							  shipping: 0.0,
							  coupon: '',
                items: [],
            }
        };

        productsKeysToFetchBy.forEach( function(element) {
            searchParams.getAll(element).forEach( function(item, idx) {

                if ( !eventObj.ecommerce.items.hasOwnProperty(idx) ) {
                    eventObj.ecommerce.items[idx] = {};
                }

                if ( element == 'productName' ) {
                    eventObj.ecommerce.items[idx]['item_name'] = item;
                }
                if ( element == 'productId' ) {
                    eventObj.ecommerce.items[idx]['item_id'] = item;
                }
                if ( element == 'productCosts' ) {
                    eventObj.ecommerce.items[idx]['price'] = item;
                }
                if ( element == 'monthlyPrice' ) {
                	  eventObj.ecommerce.items[idx]['price_total_monthly'] = item;
                }
            });
        });

			const storedEcommerceDataEncoded = sessionStorage.getItem('ecommerce');

			if (storedEcommerceDataEncoded) {
				sessionStorage.removeItem('ecommerce');
				const storedEcommerceData = JSON.parse(storedEcommerceDataEncoded);
				if (typeof storedEcommerceData === 'object' && storedEcommerceData !== null) {

					if (/*!eventObj.ecommerce.value && */storedEcommerceData.value) {
						eventObj.ecommerce.value = storedEcommerceData.value;
					}

					if (/*!eventObj.ecommerce.shipping && */storedEcommerceData.shipping) {
						eventObj.ecommerce.shipping = storedEcommerceData.shipping;
					}

					if (/*!eventObj.ecommerce.coupon && */storedEcommerceData.coupon) {
						eventObj.ecommerce.coupon = storedEcommerceData.coupon;
					}

					if (/*!eventObj.ecommerce.coupon && */storedEcommerceData.tax) {
						eventObj.ecommerce.tax = storedEcommerceData.tax;
					} else {
						eventObj.ecommerce.tax = (Math.round((Number(eventObj.ecommerce.value) * 0.081) * 100) / 100).toFixed(2);
					}

					if (storedEcommerceData.items) {
						storedEcommerceData.items.forEach(storedItem => {

							let found = false;

							eventObj.ecommerce.items.forEach((item, index) => {

								if (item.item_id === storedItem.item_id) {
									found = true;

									eventObj.ecommerce.items[index] = Object.assign(storedItem, item);

								}

							});

							if (!found) {
								console.log('[tracking] Error when tracking purchase event, items from session storage doesn\' match backend items' , 'Not matching item:', storedItem);
							}


						});

					}
					// Object.assign(userData, storedUserData, {pageType})
				}
			}


        var intervalCycle = 0;
        var gtmJs = false;
        var gtmDom = false;
        var gtmLoaded = false;
        var consentStatus = false;
        var _this = this;

        var intervalVar = setInterval(function() {

            if ( !gtmJs || !gtmDom || !gtmLoaded || !consentStatus ) {
                window.dataLayer.forEach((dataLayerElement) => {
                    if ( dataLayerElement.event == 'gtm.js' ) {
                        gtmJs = true;
                    }
                    if ( dataLayerElement.event == 'gtm.dom' ) {
                        gtmDom = true;
                    }
                    if ( dataLayerElement.event == 'gtm.load' ) {
                        gtmLoaded = true;
                    }
                    if ( dataLayerElement.event == 'consent_status' ) {
                        consentStatus = true;
                    }
                });

                if ( intervalCycle > 25 ) {
                    clearInterval(intervalVar);
                }

                intervalCycle++;
            } else {
                clearInterval(intervalVar);
                _this.pushToDataLayer(eventObj);
            }
        }, 250);

    }

    saveUrlUtmParamsToCookie() {
        const parsedUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(parsedUrl.search);

        let utmParamsObj = JSON.parse(localStorage.getItem('utm_params'));

        if (!utmParamsObj) {
            localStorage.setItem('utm_params', JSON.stringify({}));
        }

        if (!!utmParamsObj && utmParamsObj.hasOwnProperty('timestamp')) {
            const daysDiffrence = this.timeDifference(utmParamsObj);
            if (daysDiffrence > 30) {
                localStorage.setItem('utm_params', JSON.stringify({}));
            }
        }

        utmParamsObj = JSON.parse(localStorage.getItem('utm_params'));

        if (utmParamsObj.hasOwnProperty('utm_source') && utmParamsObj.hasOwnProperty('utm_medium') && utmParamsObj.hasOwnProperty('utm_campaign') && utmParamsObj.utm_source && utmParamsObj.utm_medium && utmParamsObj.utm_campaign) {
            return;
        }

        if (searchParams.get('utm_source')) {
            Object.assign(utmParamsObj, {'utm_source': searchParams.get('utm_source')});
        }
        if (searchParams.get('utm_medium')) {
            Object.assign(utmParamsObj, {'utm_medium': searchParams.get('utm_medium')});
        }
        if (searchParams.get('utm_campaign')) {
            Object.assign(utmParamsObj, {'utm_campaign': searchParams.get('utm_campaign')});
        }
        Object.assign(utmParamsObj, {'timestamp': Date.now()});

        localStorage.setItem('utm_params', JSON.stringify(utmParamsObj));

    }

    saveUrlAdTractionParamToCookie() {
        const parsedUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(parsedUrl.search);

        let adtParamsObj = JSON.parse(localStorage.getItem('adt_params'));

        if (!adtParamsObj) {
            localStorage.setItem('adt_params', JSON.stringify({}));
        }

        if (!!adtParamsObj && adtParamsObj.hasOwnProperty('timestamp')) {
            const daysDiffrence = this.timeDifference(adtParamsObj);
            if (daysDiffrence > 30) {
                localStorage.setItem('adt_params', JSON.stringify({}));
            }
        }

        adtParamsObj = JSON.parse(localStorage.getItem('adt_params'));

        if (adtParamsObj.hasOwnProperty('at_gd') && adtParamsObj.at_gd) {
            return;
        }

        if (searchParams.get('at_gd')) {
            Object.assign(adtParamsObj, {'at_gd': searchParams.get('at_gd')});
        }

        Object.assign(adtParamsObj, {'timestamp': Date.now()});

        localStorage.setItem('adt_params', JSON.stringify(adtParamsObj));

    }

    timeDifference(obj) {
        const currentTimestamp = Date.now();
        const timestamp = obj.timestamp;
        const daysDiffrence = Math.ceil((currentTimestamp - timestamp) / (1000 * 3600 * 24));
        return daysDiffrence;
    }

    intersectionCallback(entries, currentThis) {
        const _this = currentThis;

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if ( entry.target.hasAttribute('data-tracking-list') && !entry.target.hasAttribute('event-tracked') ) {
                    const closest = entry.target;
                    const children = entry.target.querySelectorAll('.swiper-slide');
                    const trackingObject = _this.createEventObject('view_item_list', entry.target, children);

                    _this.pushToDataLayer(trackingObject);

                    entry.target.setAttribute('event-tracked', true);
                }
            }
        });
    };

    createEventObject(eventName, element, childElements) {
        switch(eventName) {
            case 'view_item_list':
                eventName = 'view_item_list';
                break;
            case 'select_item':
                eventName = 'select_item';
                break;
        }

        let returnObj = {
            'event': eventName,
            'ecommerce': {
                'item_list_id': element.getAttribute('data-tracking-list-id'),
                'item_list_name': element.getAttribute('data-tracking-list-name'),
                'items': []
            }
        };

        if ( !!childElements ) {
            childElements.forEach( function(item, idx) {
                const data = JSON.parse(item.getAttribute('data-tracking-list-item'));
                if( data !== null ) {
                    returnObj.ecommerce.items.push(data);
                }
            });
        }

        return returnObj;

    }

    trackingSliderViewItemList(obj) {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                this.intersectionCallback(entries, this);
            });
            const observedItems = document.querySelectorAll('.swiper-wrapper');

            observedItems.forEach( ( observedItem ) => {
                observer.observe(observedItem);
            });
        }
    }

    trackingSliderViewItemListClick() {
        const _this = this;
        const selectedItems = document.querySelectorAll('app-addtocart .widget__label');

        selectedItems.forEach((item) => {
            item.addEventListener('click', (event) => {
                if ( !event.target.hasAttribute('event-tracked') ) {
                    const sliderWrapper = event.target.closest('.swiper-wrapper');
                    const children = event.target.closest('.swiper-slide');
                    const trackingObject = _this.createEventObject('select_item', sliderWrapper, [children]);

                    if ( trackingObject.ecommerce.items.length > 0 ) {
                        _this.pushToDataLayer(trackingObject);
                        event.target.setAttribute('event-tracked', true);
                    }
                }
            });
        });
    }

    init() {
        this.saveUrlUtmParamsToCookie();
        this.saveUrlAdTractionParamToCookie();
        this.generalPageTracking();
        this.cmsContentTracking();
        this.cmsCheckoutSuccessTracking();
        this.cmsCheckoutSuccessTrackingAfterPaymentOnSuccessPage();
        this.trackingSliderViewItemList();
        this.trackingSliderViewItemListClick();
    }
}
